import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import bowser from 'bowser';
import { connect } from 'react-redux';
import PreviousPayrolls from './PreviousPayrolls';
import { Table, THead, TBody, Row, Cell } from '../../../core/Table';

import ModalPassword from '../../ModalPassword';
import {
  AccordionActionsItem,
  AccordionActionsItemPrimary,
  AccordionActionsItemSecondary
} from '../../../core/AccordionActions';
import Icon from '../../../core/Icon';
import { Warning, Download } from '../../../../../assets/images/index';

import PayrrollIncidence from './PayrrollIncidence';

import SelectEmployeeDirectory from '../../../containers/SelectEmployeeDirectory';

import {
  StyledMain,
  StyledWrapper,
  StyledBoxContainer,
  StyledModal,
  StyledAccordionActions,
  StyledAccordionActionsTableInfo,
  StyledText,
  StyledCellDownload,
  StyledTwoLevelBreadcrumb,
  StyledPayrollNotice
} from './style';

const A3MIA_PAYROLL_URL =
  'https://fa-extj-saasfaprod1.fa.ocs.oraclecloud.com/fscmUI/redwood/payslips/payslips/launch';

class Payroll extends Component {
  constructor(props) {
    super(props);
    this.state = {
      directDownload: false,
      formPayrroll: false
    };
  }

  openIncidence = () => {
    const { formPayrroll } = this.state;

    this.setState({ formPayrroll: !formPayrroll });
  };

  render() {
    const {
      payrollsListWithSensitiveData,
      years,
      months,
      changeYear,
      onSelectPreviousPayroll,
      onErrorLoadData,
      checkPassword,
      modalPassword,
      modalPayrollsList,
      modalRRHH,
      hideModalPassword,
      hideModalPayrollsList,
      openModalRRHH,
      onClickPayrollWithSensitiveData,
      errorDni,
      roles,
      employeeSelected,
      setEmployeeSelected,
      listManagedUsers
    } = this.props;
    const { directDownload, formPayrroll } = this.state;

    return (
      <StyledMain>
        <StyledWrapper formPayrroll={formPayrroll}>
          {formPayrroll && (
            <StyledTwoLevelBreadcrumb
              first="Nominas"
              second="Buzón de atención al empleado"
              onBack={() => {
                this.setState({
                  formPayrroll: false
                });
              }}
            />
          )}
          {onErrorLoadData ? (
            <p>Lo sentimos, pero no existen datos para su usuario</p>
          ) : (
            <Fragment>
              {!formPayrroll && (
                <Fragment>
                  <StyledPayrollNotice>
                    <Icon
                      svg={Warning}
                      size="sm"
                      color="warning"
                      className="notice-icon"
                    />
                    <div>
                      <strong>Las nóminas más recientes están en A3MIA</strong>
                      Desde enero de 2026, las nóminas se consultan y descargan
                      en A3MIA. En esta página puedes seguir consultando las
                      nóminas de 2024 y anteriores.{' '}
                      <a
                        href={A3MIA_PAYROLL_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        id="linkPayrollA3mia"
                      >
                        Ir a A3MIA
                      </a>
                    </div>
                  </StyledPayrollNotice>
                  {/* <StyledBoxContainer className="mb-30">
                    <LatestPayrolls
                      payRolls={latestPayrollList}
                      onSelect={payroll => {
                        this.setState({ directDownload: true });
                        onSelectLatestPayroll(payroll.rawData);
                      }}
                    />
                  </StyledBoxContainer> */}
                  <StyledBoxContainer className="mb-30">
                    <PreviousPayrolls
                      years={years}
                      months={months}
                      listManagedUsers={listManagedUsers}
                      onChangeYears={changeYear}
                      employeeSelected={employeeSelected}
                      setEmployeeSelected={setEmployeeSelected}
                      onClickBtn={(
                        yearSelected,
                        monthSelected,
                        employeeSelected
                      ) => {
                        this.setState({ directDownload: false });
                        onSelectPreviousPayroll(
                          yearSelected,
                          monthSelected,
                          employeeSelected
                        );
                      }}
                      openModalRRHH={openModalRRHH}
                    />
                  </StyledBoxContainer>
                </Fragment>
              )}
              <StyledBoxContainer className="mb-30">
                <PayrrollIncidence
                  formPayrroll={formPayrroll}
                  onClickOpenIncidence={this.openIncidence}
                />
              </StyledBoxContainer>
            </Fragment>
          )}
        </StyledWrapper>
        {modalPassword && (
          <ModalPassword
            action={nif => checkPassword(nif, directDownload)}
            clickCloseIcon={hideModalPassword}
            errorDni={errorDni}
          />
        )}
        {modalPayrollsList &&
          (bowser.mobile ? (
            <StyledModal
              title="DESCARGA TU NÓMINA"
              clickCloseIcon={hideModalPayrollsList}
            >
              <StyledText>
                Selecciona la nómina que quieras descargar
              </StyledText>
              {payrollsListWithSensitiveData?.map(item => (
                <StyledAccordionActions>
                  <AccordionActionsItem>
                    <AccordionActionsItemPrimary
                      title="Fecha de imputación"
                      subtitle={item.allocationDate}
                      type="button"
                    >
                      <Icon
                        svg={Download}
                        onClick={() => {
                          this.setState({ directDownload: true });
                          onClickPayrollWithSensitiveData(item);
                        }}
                      />
                    </AccordionActionsItemPrimary>
                    <AccordionActionsItemSecondary>
                      <StyledAccordionActionsTableInfo>
                        <tbody>
                          <tr>
                            <th>Total devengado</th>
                            <td>{item.totalAccruement}</td>
                          </tr>
                          <tr>
                            <th>Total retenido</th>
                            <td>{item.totalWithholding}</td>
                          </tr>
                          <tr>
                            <th>Líquido</th>
                            <td>{item.totalLiquid}</td>
                          </tr>
                        </tbody>
                      </StyledAccordionActionsTableInfo>
                    </AccordionActionsItemSecondary>
                  </AccordionActionsItem>
                </StyledAccordionActions>
              ))}
            </StyledModal>
          ) : (
            <StyledModal
              title="DESCARGA TU NÓMINA"
              clickCloseIcon={hideModalPayrollsList}
            >
              <StyledText>
                Selecciona la nómina que quieras descargar
              </StyledText>
              <Table summary="Datos de la nómina">
                <THead>
                  <Row>
                    <Cell tagName="th" scope="col">
                      Fecha imputación
                    </Cell>
                    <Cell tagName="th" scope="col">
                      Total devengado
                    </Cell>
                    <Cell tagName="th" scope="col">
                      Total retenido
                    </Cell>
                    <Cell tagName="th" scope="col">
                      Líquido
                    </Cell>
                    <Cell tagName="th" scope="col" />
                  </Row>
                </THead>
                <TBody>
                  {payrollsListWithSensitiveData?.map(item => (
                    <Row>
                      <Cell>{item?.allocationDate}</Cell>
                      <Cell>{item?.totalAccruement}</Cell>
                      <Cell>{item?.totalWithholding}</Cell>
                      <Cell>{item?.totalLiquid}</Cell>
                      <StyledCellDownload>
                        <Icon
                          svg={Download}
                          onClick={() => {
                            this.setState({ directDownload: true });
                            onClickPayrollWithSensitiveData(item);
                          }}
                        />
                      </StyledCellDownload>
                    </Row>
                  ))}
                </TBody>
              </Table>
            </StyledModal>
          ))}
        {roles.includes('ROLE_ACCESS_RRHH') && modalRRHH && (
          <SelectEmployeeDirectory setEmployeeSelected={setEmployeeSelected} />
        )}
      </StyledMain>
    );
  }
}

Payroll.propTypes = {
  changeYear: PropTypes.func,
  onErrorLoadData: PropTypes.bool,

  // latestPayrollList: PropTypes.arrayOf(
  // PropTypes.shape({
  // month: PropTypes.string,
  // year: PropTypes.number
  // })
  // ),
  payrollsListWithSensitiveData: PropTypes.arrayOf(
    PropTypes.shape({
      month: PropTypes.string,
      year: PropTypes.number
    })
  ),
  years: PropTypes.arrayOf(
    PropTypes.shape({
      allocationDate: PropTypes.string,
      payslipDate: PropTypes.string,
      payslipType: PropTypes.string,
      totalAccruement: PropTypes.number,
      totalLiquid: PropTypes.number,
      totalWithholding: PropTypes.number
    })
  ),
  months: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      text: PropTypes.string,
      id: PropTypes.number
    })
  ),
  modalPassword: PropTypes.bool,
  modalPayrollsList: PropTypes.bool,
  hideModalPassword: PropTypes.func,
  hideModalPayrollsList: PropTypes.func,
  onClickPayrollWithSensitiveData: PropTypes.func,
  // onSelectLatestPayroll: PropTypes.func,
  onSelectPreviousPayroll: PropTypes.func,
  checkPassword: PropTypes.func,
  errorDni: PropTypes.bool
};

const mapStateToProps = state => ({
  roles: state.user.user.roles
});

export default connect(mapStateToProps)(Payroll);
